import clsx from 'clsx';
import FocusTrap from 'focus-trap-react';
import { observer } from 'mobx-react';
import * as React from 'react';
import { OpenableState } from '../../../../Modal/UseOpenable';

export interface Props {
  content: React.JSX.Element;
  modalState: OpenableState;
}

const ActionItemsPopover: React.FC<Props> = ({ content, modalState }) => {
  switch (modalState.kind) {
    case 'open':
      return (
        <FocusTrap
          active={true}
          focusTrapOptions={{
            escapeDeactivates: false,
            allowOutsideClick: true,
            fallbackFocus: '#popover-container',
            preventScroll: true,
          }}
        >
          <div
            className={clsx(
              'absolute w-56 p-2 border-[1px] bg-white text-sm z-10',
              'ml-[-15rem] mt-[-1rem] rounded-md border-solid border-gray-300 text-gray-800',
              'shadow-[0px_6px_20px_-2px_rgba(26,26,26,0.14),0px_4px_6px_rgba(26,26,26,0.06)]',
            )}
          >
            {content}
          </div>
        </FocusTrap>
      );
    case 'closed':
      return <></>;
  }
};

export default observer(ActionItemsPopover);
